import dayjs from "dayjs";

export const toDateOnlyIso = (date: Date | string) =>
  dayjs(date).format("YYYY-MM-DD[T]00:00:00.000[Z]");
